import { useLocation } from "react-router-dom";
import "./SingleUserResult.css";
import { useEffect, useRef, useState } from "react";
import GetSingleClass from "../../../../Controllers/Admin/ClassAndCourses/GetSingleClass";
import { useReactToPrint } from "react-to-print";

const SingleUserResult = () => {
  const location = useLocation();
  const {
    name,
    gender,
    regNo,
    ClassId,
    CourseName,
    image,
    ExamType,
    ObtainedMarks,
    ExamTotalMarks,
  } = location.state.user;

  const [ExamClass, setExamClass] = useState();

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  useEffect(() => {
    const fetchData = async () => {
      if (ClassId) {
        let resp = await GetSingleClass(ClassId);
        setExamClass(resp);
      }
    };
    fetchData();
  }, []);

  return (
    <div className="page-wrapper admin-view-result-page">
      <div className="content container-fluid">
        <div className="page-header">
          <div className="row align-items-center">
            <div className="col">
              <h3 className="page-title">User Result</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="#">Dashboard</a>
                </li>
                <li className="breadcrumb-item active">User Result</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="user-result" ref={componentRef}>
          <div className="user-result-header-section">
            <img
              alt="User Image"
              src={
                image
                  ? image
                  : require("../../../../Assets/images/profile/profile.png")
              }
            />
            <div>
              <h3>
                <span
                  style={{
                    color: "rgb(96,112,207)",
                  }}
                >
                  Name:&nbsp;
                </span>
                {name}
              </h3>
              <h4>
                {" "}
                <span
                  style={{
                    color: "rgb(96,112,207)",
                  }}
                >
                  Reg No:&nbsp;
                </span>{" "}
                {regNo}
              </h4>
              <h5>
                <span
                  style={{
                    color: "rgb(96,112,207)",
                  }}
                >
                  Gender:&nbsp;
                </span>{" "}
                {gender}
              </h5>
            </div>
          </div>
          <div className="result-bottom-section">
            <div>
              <h4>Class : {ExamClass?.ClassName}</h4>
              <h4>Course : {CourseName}</h4>
            </div>
            <div>
              <h5>Exam Type: {ExamType}</h5>
              <h6>Total Marks: {ExamTotalMarks}</h6>
              <h6>Obtained Marks: {ObtainedMarks}</h6>
            </div>
          </div>
        </div>
        <div className="print-result-btn-container">
          <button onClick={handlePrint}>Print</button>
        </div>
      </div>
    </div>
  );
};

export default SingleUserResult;
